import {
  updateAnnotationsEndpoint,
  createAnnotationsEndpoint,
  deleteAnnotationEndpoint,
  deleteAnnotationsEndpoint,
  sanityCheckAnnotationsEndpoint,
} from "./api/Annotations";

export const updateAnnotationsInDatabase = async (correctedAnnotations, id) => {
  try {
    const response = await updateAnnotationsEndpoint(correctedAnnotations, id);
    return response;
  } catch (error) {
    throw new Error(`Error updating annotations: ${error.message}`);
  }
};

export const createAnnotationsInDatabase = async (annotationData, instanceId) => {
  try {
    const response = await createAnnotationsEndpoint(annotationData, instanceId);
    return response;
  } catch (error) {
    throw new Error(`Error creating annotations: ${error.message}`);
  }
};

export const deleteAnnotationInDatabase = async (id) => {
  try {
    const response = await deleteAnnotationEndpoint(id);
    return response;
  } catch (error) {
    throw new Error(`Error deleting annotation: ${error.message}`);
  }
};

export const deleteAnnotationsInDatabase = async (instanceId, annotationIds) => {
  try {
    const response = await deleteAnnotationsEndpoint(instanceId, {
      annotationIds,
    });
    return response;
  } catch (error) {
    throw new Error(`Error deleting annotations: ${error.message}`);
  }
};

/**
 * Run sanity checks on annotations before persisting.
 * @param {Object} annotations - Annotations in anno_id_dict format: {"2000": [x, y, z], ...}
 * @returns {Promise<Object>} - { valid: boolean, error_count: number, errors: { [type]: [{id, type, message, landmark_ids}] } }
 */
export const sanityCheckAnnotations = async annotations => {
  try {
    const response = await sanityCheckAnnotationsEndpoint(annotations);
    // Parse the response if it's a string (from CommandResponse)
    if (typeof response === "string") {
      return JSON.parse(response);
    }
    if (response.data && typeof response.data === "string") {
      return JSON.parse(response.data);
    }
    return response;
  } catch (error) {
    throw new Error(`Error checking annotations: ${error.message}`);
  }
};
